import { useState, PropsWithChildren } from 'react';
import { RestrictedAccessExplanation } from '@/creditflowresearch/ui/common/components/Explanations';
import { LOCKED_SUBSCRIBE_DESCRIPTION, LOCKED_SUBSCRIBE_TITLE } from './constants';

import styles from './tileSubscribeButton.module.scss';

interface IProps extends PropsWithChildren {
  isLocked: boolean,
}

// TODO: remove when the European market opening period ends
const TileSubscribeLockedPopup = ({ isLocked, children }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!isLocked) {
    return <>{ children }</>;
  }

  return (
    <RestrictedAccessExplanation
      title={ LOCKED_SUBSCRIBE_TITLE }
      description={ LOCKED_SUBSCRIBE_DESCRIPTION }
      isOpen={ isOpen }
      setIsOpen={ setIsOpen }
      closeTooltip={ () => setIsOpen(false) }
      triggerEvent="hover"
      placement="bottom-end"
    >
      <span className={ styles.lockedTrigger } data-test="tileSubscribeLockedTrigger">
        { children }
      </span>
    </RestrictedAccessExplanation>
  );
};

export default TileSubscribeLockedPopup;
